import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How long is your coding schlong?",
  "description": "",
  "published": "2010-04-07T00:00:00.000Z",
  "redirect_from": ["/blog/how-long-is-your-coding-schlong/swizec/1287"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Every now and then a new silly service pops up that helps people measure the length of their penis and compare it to others without being ... you know ... very ew about it.`}</p>
    <p>{`'cause nobody wants that`}</p>
    <p>{`nope.`}</p>
    <p>{`So one of these days, doesn't really matter when, but I found out about it today, a new service called MyTechne popped up out of the blue ... and oh great, Zemanta just flashed me with a bunch of dicks in the recommendations media gallery, thanks guise ...`}</p>
    <p>{`The point is that you sign up and create a collection of all the different programming languages you've ever used and when you used them and so on and so forth. Marvelous!`}</p>
    <p>{`Now the age long debate of who has the biggest coding schlong over at the pub can get fucking substantiated. Why try to remember everything when you're drunk out of your mind? Just pull out an internet and SHOW them.`}</p>
    <p>{`As Hugh Laurie would say in Blackadder's fourth series: Hoorah!!`}</p>
    <p>{`Anyway, here's `}<a parentName="p" {...{
        "href": "http://mytechne.com/user/Swizec/"
      }}>{`my coding schlong`}</a>{` if anyone's interested. For the love of god DO show me yours in the comments alright. Cheers.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/04/Screen-shot-2010-04-07-at-4.21.12-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/04/Screen-shot-2010-04-07-at-4.21.12-PM.png",
          "alt": null
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      